import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import AddBookingDetailsForm from './form/add-booking-details-form'
import CompleteServiceBookingForm from './form/complete-service-booking-form'
import AddServiceRecordForm from './form/add-service-record-form'
import { fetchServiceBooking, reset } from 'features/report-vehicle-servicing/actions'
import moment from 'moment'
import { constants } from '../../../module'
import { useEnabledFeatureToggleList } from 'features/settings'
import { hasRoles } from 'acl'
import { useIsAlfaDownDisableFeatures } from 'features/drivers'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import ServiceBookingsContent from './service-bookings'

const viewConstants = {
  SERVICE_BOOKING_MENU: 'MENU',
  ADD_BOOKING_DETAILS_FORM: 'ADD_BOOKING_DETAILS_FORM',
  ADD_SERVICE_RECORD_FORM: 'ADD_SERVICE_RECORD_FORM',
  VIEW_SERVICE_BOOKING: 'VIEW_SERVICE_BOOKING',
}

const getInitialActiveView = () =>
  window.location.pathname.includes(constants.PATH_SERVICE_BOOKINGS_ADD_SERVICE_RECORD)
    ? viewConstants.ADD_SERVICE_RECORD_FORM
    : viewConstants.SERVICE_BOOKING_MENU

const ServiceBookings = ({
  id,
  flags,
  apiResponse,
  driverData,
  fleetData,
  serviceBookingData,
  onReset,
  onFetchServiceBooking,
  userRoles,
}) => {
  const navigate = useNavigate()
  const featureToggleList = useEnabledFeatureToggleList()

  const disableOutOfHoursFeatureToggle = featureToggleList.includes('OutOfHoursDisabled')
  const isAlfaDownDisableDriverFeatures = useIsAlfaDownDisableFeatures()
  const disabled = disableOutOfHoursFeatureToggle ? false : isAlfaDownDisableDriverFeatures
  const disableButtons = disabled ? true : hasRoles(['fleetcoordinator'], userRoles)

  const [activeView, setActiveView] = useState(getInitialActiveView)

  useEffect(() => {
    onReset()
    onFetchServiceBooking(id)
  }, []) // eslint-disable-line

  useEffect(() => {
    if (
      flags?.completeServiceBooking === 'processed' ||
      flags?.cancelServiceBooking === 'processed' ||
      flags?.addServiceBooking === 'processed'
    ) {
      onFetchServiceBooking(id)
    }

    if (flags?.cancelServiceBooking === 'processed') {
      setActiveView(viewConstants.SERVICE_BOOKING_MENU)
    }

    if (window.location.pathname.includes(constants.PATH_SERVICE_BOOKINGS_ADD_SERVICE_RECORD)) {
      setActiveView(viewConstants.ADD_SERVICE_RECORD_FORM)
    }
  }, [flags?.completeServiceBooking, flags?.cancelServiceBooking, flags?.addServiceBooking]) // eslint-disable-line

  const serviceBookingExistsInTheFuture =
    serviceBookingData?.bookedDate &&
    moment(serviceBookingData.bookedDate).isAfter(moment(), 'day')

  if (serviceBookingExistsInTheFuture) {
    return (
      <AddBookingDetailsForm
        readOnly
        fleetData={fleetData}
        serviceBookingData={serviceBookingData}/>
    )
  }

  if (
    serviceBookingData?.bookedDate &&
    (moment(serviceBookingData.bookedDate).isSame(moment(), 'day') ||
      moment(serviceBookingData.bookedDate).isBefore(moment()))
  ) {
    return (
      <CompleteServiceBookingForm
        readOnly={disableButtons}
        fleetData={fleetData}
        serviceBookingData={serviceBookingData}/>
    )
  }

  return (
    <>
      {activeView === viewConstants.ADD_BOOKING_DETAILS_FORM ? (
        <AddBookingDetailsForm
          fleetData={fleetData}
          onBack={() => setActiveView(viewConstants.SERVICE_BOOKING_MENU)}/>
      ) : activeView === viewConstants.ADD_SERVICE_RECORD_FORM ? (
        <AddServiceRecordForm
          fleetData={fleetData}
          onBack={() => {
            setActiveView(viewConstants.SERVICE_BOOKING_MENU)
            navigate(`${constants.PATH_ALL}/${id}${constants.PATH_SERVICE_BOOKINGS}`)
          }}/>
      ) : (
        <ServiceBookingsContent>
          <Stack flexDirection={{ xs: 'column', md: 'row' }} gap={{ xs: 1, md: 2 }}>
            <Stack minWidth={{ xs: '100%', md: '205px' }}>
              <Button variant="contained" onClick={() => setActiveView(viewConstants.ADD_BOOKING_DETAILS_FORM)}>
                Add Booking Details
              </Button>
            </Stack>
            <Stack minWidth={{ xs: '100%', md: '205px' }}>
              <Button
                variant="contained"
                onClick={() => {
                  onReset()
                  setActiveView(viewConstants.ADD_SERVICE_RECORD_FORM)
                }}>
                Add Service Record
              </Button>
            </Stack>
          </Stack>
        </ServiceBookingsContent>
      )}
    </>
  )
}

const mapStateToProps = ({ reportVehicleServicing, fleet, settings }, ownProps) => ({
  flags: reportVehicleServicing.flags,
  apiResponse: reportVehicleServicing.apiResponse || '',
  driverData: fleet.related,
  fleetData: fleet.data?.[ownProps.id],
  serviceBookingData: reportVehicleServicing?.relatedServiceBooking || {},
  userRoles: settings.roles,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchServiceBooking: (agreementNo) =>
    dispatch(fetchServiceBooking(null, { resourceId: agreementNo })),
  onReset: () => dispatch(reset()),
})

const Connected = connect(mapStateToProps, mapDispatchToProps)(ServiceBookings)

export default function ServiceBookingsWithParams(props) {
  const { id } = useParams()
  return <Connected {...props} id={id} />
}
